class BbdTooltip extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');

    if (!this.button) return;

    this.button.addEventListener('click', (event) => {
      event.stopPropagation();
      this.toggle();
    });

    this.addEventListener('mouseenter', () => this.open());
    this.addEventListener('mouseleave', () => this.close());
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.close();
      }
    });
  }

  toggle() {
    this.hasAttribute('open') ? this.close() : this.open();
  }

  open() {
    this.setAttribute('open', '');
    this.button?.setAttribute('aria-expanded', 'true');
  }

  close() {
    this.removeAttribute('open');
    this.button?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('bbd-tooltip')) {
  customElements.define('bbd-tooltip', BbdTooltip);
}
